import { Icons } from '@ohif/ui-next';
import React from 'react';
import { PredictionsPanelIcon } from './components/panels/predictions/PredictionsPanelIcon';
import { PredictionsPanel } from './components/panels/predictions/PredictionsPanel';
import { CleaningPanel } from './components/panels/cleaning/CleaningPanel';

export const PREDICTIONS_PANEL_NAME = 'predictions-panel';
export const CLEANING_PANEL_NAME = 'cleaning-panel';

// OHIF 3.10's PanelService only forwards a string `iconName` (resolved against the
// ui-next Icons registry) and drops the `icon` React element, so register the
// prediction panel icon under a name and reference it via `iconName` below.
Icons.addIcon('gleamer-predictions', PredictionsPanelIcon);

export function getPanelModule({
  servicesManager,
  commandsManager,
  extensionManager,
}) {
  return [
    {
      id: PREDICTIONS_PANEL_NAME,
      name: PREDICTIONS_PANEL_NAME,
      iconName: 'gleamer-predictions',
      iconLabel: 'Predictions',
      label: 'Predictions',
      component: (props) => {
        return (
          <PredictionsPanel servicesManager={servicesManager} {...props} />
        );
      },
    },
    {
      id: CLEANING_PANEL_NAME,
      name: CLEANING_PANEL_NAME,
      iconName: 'gleamer-predictions',
      iconLabel: 'Cleaning',
      label: 'Cleaning',
      component: (props) => {
        return <CleaningPanel servicesManager={servicesManager} {...props} />;
      },
    },
  ];
}
